module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.view == 'index') ? [(_vm.loading.templates) ? _c('spinner') : _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "pagination-options": {
        'enabled': true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "highlight"
        }, [_c('div', {
          staticClass: "warning"
        }), _vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'type') ? _c('span', {
          staticClass: "capitalize"
        }, [_vm._v(_vm._s(props.row.type))]) : (props.column.field == 'publish') ? _c('span', [_c('span', {
          staticClass: "label label-sm",
          class: [props.row.publish == 'Published' ? 'label-warning' : 'label-danger']
        }, [_vm._v(" " + _vm._s(props.row.publish) + " ")])]) : (props.column.field == 'actions') ? [_c('div', {
          staticClass: "last-dropdown"
        }, [_c('actions-menu', [_c('actions-menu-item', {
          attrs: {
            "title": "Edit",
            "icon": "fa-edit"
          },
          on: {
            "click": function($event) {
              return _vm.switchToEditTemplate(props.row.id)
            }
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Duplicate",
            "icon": "fa-copy"
          },
          on: {
            "click": function($event) {
              return _vm.duplicateTemplate(props.row.id)
            }
          }
        }), _vm._v(" "), _c('actions-menu-item', {
          attrs: {
            "title": "Delete",
            "icon": "fa-trash"
          },
          on: {
            "click": function($event) {
              return _vm.removeTemplate(props.row.id)
            }
          }
        })], 1)], 1)] : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 2869474883)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    No templates available.\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn green margin-top-10 pull-right",
    on: {
      "click": function($event) {
        return _vm.switchToEditTemplate(null)
      }
    }
  }, [_vm._v("Create New Template")]), _vm._v(" "), _c('div', {}, [_vm._v(" ")])], 1)] : (_vm.view == 'editTemplate') ? [_c('edit-template', {
    attrs: {
      "templateId": _vm.editTemplateId
    },
    on: {
      "back": _vm.switchToIndex
    }
  })] : _vm._e(), _vm._v(" "), (_vm.showDuplicateTemplateModal) ? _c('duplicate-template-modal', {
    attrs: {
      "duplicate-template-id": _vm.duplicateTemplateId
    },
    on: {
      "hide": function($event) {
        _vm.showDuplicateTemplateModal = false
      },
      "duplicate-success": _vm.templateDuplicated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDeleteTemplateModal) ? _c('delete-template-modal', {
    attrs: {
      "delete-template-id": _vm.deleteTemplateId
    },
    on: {
      "hide": function($event) {
        _vm.showDeleteTemplateModal = false
      },
      "delete-success": _vm.templateDeleted
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-750548dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/TemplatesIndex.vue
// module id = 1697
// module chunks = 1